import React, { FC, useState } from 'react';
import { Alert, Container } from 'react-bootstrap';
import FacebookLogin from '../../components/authentication/FacebookLogin';
import GoogleLogin from '../../components/authentication/GoogleLogin';
import KreezeeLogin from '../../components/authentication/KreezeeLogin';
import { LoginAvatar } from '../../components/icons/LoginAvatar';
import LanguageSelect from '../../components/user/language/LanguageSelect';
import KreezeeCreateAccount from '../../components/authentication/KreezeeCreateAccount';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory, useParams } from 'react-router';

interface Props {
  isCreateAccount: boolean;
}

const LoginPage: FC<Props> = ({ isCreateAccount }) => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { invitationId } = useParams<{ invitationId?: string | undefined }>();

  const history = useHistory();
  const intl = useIntl();

  return (
    <>
      <div className="background"></div>

      <Container fluid className="login-container">
        <div className="login-header">
          <img
            src="https://cache.kreezee.com/home/logos/flat_renverse_logo_kreezee_no_border.svg"
            alt="Kreezee Sports"
          />
          <LanguageSelect color="#fff" />
        </div>
        <Container className="kreezee-login-container">
          <div className="d-inline-flex flex-wrap justify-content-center">
            <div className="d-inline-flex">
              <h3 className="title">FR</h3>
              <h3 className="title primary">O</h3>
              <h3 className="title me-3">NT</h3>
            </div>

            <div className="d-inline-flex">
              <h3 className="title primary">O</h3>
              <h3 className="title">FFICE</h3>
            </div>
          </div>
          {error && (
            <div className="position-relative mt-3" style={{ display: 'block' }}>
              <Alert variant="danger" className="mb-0">
                {error}
              </Alert>
            </div>
          )}
          <div className="login-items mt-3">
            {!isCreateAccount && (
              <KreezeeLogin setError={setError} loading={loading} setLoading={setLoading} invitationId={invitationId} />
            )}
            {isCreateAccount && <KreezeeCreateAccount invitationId={invitationId} setError={setError} />}

            <div className="or-label">
              <FormattedMessage id="loginPage.or"></FormattedMessage>
            </div>
            <div className="login-providers">
              <FacebookLogin setError={setError} />
              <GoogleLogin setError={setError} />
            </div>

            <div className="mt-4">
              <a
                className="account-link"
                onClick={() =>
                  history.push(
                    isCreateAccount
                      ? `/login${invitationId ? `/${invitationId}` : ''}`
                      : `/create-account${invitationId ? `/${invitationId}` : ''}`,
                  )
                }
              >
                <span>
                  {isCreateAccount
                    ? intl.formatMessage({ id: 'loginPage.alreadyHaveAccount' })
                    : intl.formatMessage({ id: 'loginPage.noAccount' })}
                </span>
                <span className="action">
                  {isCreateAccount
                    ? intl.formatMessage({ id: 'loginPage.logIn' })
                    : intl.formatMessage({ id: 'loginPage.signUp' })}
                </span>
              </a>
            </div>
            <div className="login-avatar-wrapper d-none d-lg-block d-xl-block">
              <LoginAvatar width={200} height={253} />
            </div>
          </div>
        </Container>
      </Container>
    </>
  );
};

export default LoginPage;
